<template>
	<div :class="showHeader ? 'header show-header' : 'header'">
		<div class="container">
			<div class="logo">
				<img :src="logo" alt="logo">
			</div>
			<div class="header-nav">
				<span v-for="item in navigationList" :key="item.navigationId" class="item">
					<router-link class="router"
						:to="!item.children || item.children.length == 0 ? item.link + '?' + 'navigationId=' + item.navigationId : ''">
						<el-dropdown v-if="item.children" placement="bottom-start" :append-to-body="true"
							popper-class="dropdown" @command="toProdect">
							<span class="el-dropdown-link">
								<span>{{ item.navigationName }}</span>
								<span class="underline"></span>
							</span>
							<el-dropdown-menu slot="dropdown" class="el-dropdown-menu">
								<template v-if="item.children.length > 0 && !item.children[0].children">
									<!-- <template v-if="handleDisplay(item.children)">
										<div class="item-flex" style="display: flex;" @mouseleave="handleMouseLeave">
											<div>
												<div v-for="childrenItem in item.children" :key="childrenItem.navigationId">
													<template v-if="childrenItem.children">
														<div class="item" style="list-style: none; text-align: center; line-height: 36px; font-size: 14px; cursor: pointer;" @mouseenter="handleMouseEnter(childrenItem)">
															{{ childrenItem.navigationName }}
														</div>
													</template>
													<template v-else>
														<el-dropdown-item class="item" :command="childrenItem">
															<span @mouseenter="handleMouseEnter(childrenItem)">
																{{ childrenItem.navigationName }}
															</span>
														</el-dropdown-item>
													</template>
												</div>
											</div>
											<div>
												<div v-for="grandChildrenItem in childrenItem" :key="grandChildrenItem.navigationId">
													<el-dropdown-item class="item" :command="grandChildrenItem">
														{{ grandChildrenItem.navigationName }}
													</el-dropdown-item>
												</div>
											</div>
										</div>
									</template>
									<template v-else> -->
										<div style="display: grid;grid-template-columns: 1fr 1fr;">
											<div v-for="childrenItem in item.children" :key="childrenItem.navigationId">
												<el-dropdown-item class="item" :command="childrenItem">
													{{ childrenItem.navigationName }}
												</el-dropdown-item>
											</div>
										</div>
									<!-- </template> -->
								</template>
								<template v-else>
									<div style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr;column-gap: 30px;">
										<div v-for="childrenItem in item.children" :key="childrenItem.navigationId">
											<div style="padding: 10px 20px;display: flex;">
												<div class="second-title">
													{{ childrenItem.navigationName }}
												</div>
												<div class="icon">
													<i class="el-icon-arrow-right"></i>
												</div>
											</div>
											<div style="display: grid;grid-template-columns: 1fr;">
												<el-col v-for="grandChildrenItem in childrenItem.children"
													:key="grandChildrenItem.navigationId">
													<el-dropdown-item class="third-title" :command="grandChildrenItem">
														{{ grandChildrenItem.navigationName }}
													</el-dropdown-item>
												</el-col>
											</div>
										</div>
									</div>
								</template>
							</el-dropdown-menu>
						</el-dropdown>
						<span v-else class="el-dropdown-link">
							<span>{{ item.navigationName }}</span>
							<span class="underline"></span>
						</span>
					</router-link>
				</span>
			</div>
			<div class="phone-consult">
				<el-tooltip class="item" effect="dark" content="0791-88861315" placement="bottom">
					<div>
						<i class="el-icon-phone" style="color: #fff"></i>
						<span class="phone-text">电话咨询</span>
					</div>
				</el-tooltip>
			</div>
		</div>
		<TreeDropdown class="tree-menu" :treeData="navigationList" @node-click="handleSelect" />
	</div>
</template>

<script>
import AppFunctions from "@/utils/AppFunctions";
import { handleTree } from "@/utils/admin";
import { queryNavigation } from "@/api/navigation";
import TreeDropdown from '@/components/TreeDropdown.vue';
import logo from '@/assets/logo.png';
import { EventBus } from '@/eventBus';
export default {
	name: "Header",
	components: {
		TreeDropdown,
	},
	data() {
		return {
			navigationList: [],
			childrenItem: [],
			logo: logo,
			menuOpen: false,
			showHeader: false,
		}
	},
	mounted() {
		window.addEventListener("wheel", this.wheelHandle);
		EventBus.$on('showHeader', this.handleOpenHeader);
	},
	destroyed() {
		window.removeEventListener("wheel", this.wheelHandle);
		EventBus.$off('showHeader');
	},
	methods: {
		wheelHandle(event) {
			if (event.deltaY > 0 && !this.showHeader) {
				this.showHeader = true;
			}
			if (event.deltaY < 0 && this.showHeader) {
				this.showHeader = false;
			}
		},
		toggleStickyHeader() {
			const scrolled = document.documentElement.scrollTop;
			if (scrolled > 100) {
				AppFunctions.addClass('.header-default', 'sticky');
			} else if (scrolled <= 100) {
				AppFunctions.removeClass('.header-default', 'sticky');
			}
		},
		getNavigation() {
			const data = {
				navigationClassify: 0
			}
			queryNavigation(data).then(res => {
				this.navigationList = handleTree(res.data, "navigationId", "parentId");
			})
		},
		toProdect(command) {
			this.$router.push({
				path: command.link,
				query: {
					navigationId: command.navigationId
				}
			})
		},
		handleOpen(index) {
			if (index == 0) {
				this.menuOpen = true;
			}
		},
		handleClose(index) {
			if (index == 0) {
				this.menuOpen = false;
			}
		},
		handleSelect(item) {
			if (item.children && item.children.length > 0) {
				return;
			}
			this.menuOpen = false;
			let dom = document.querySelector('.el-submenu__title');
			if (dom) {
				dom.click();
			}
			this.$router.push({
				path: item.link,
				query: {
					navigationId: item.navigationId
				}
			})
		},
		handleOpenHeader() {
			this.showHeader = false;
		},
		handleDisplay(items) {
			return items.some(item => item.children && item.children.length > 0);
		},
		handleMouseEnter(item) {
			if (item.children && item.children.length > 0) {
				this.childrenItem = item.children;
			} else {
				this.childrenItem = [];
			}
		},
		handleMouseLeave() {
			this.childrenItem = [];
		}
	},
	created() {
		this.getNavigation();
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleStickyHeader);
	}

}
</script>

<style lang="scss" scoped>
.show-header {
	transform: translate(0, -100%);
}

.header {
	position: fixed;
	top: 0;
	z-index: 20;
	display: flex;
	justify-content: center;
	width: 100%;
	height: 75px;
	background-color: #fcfdfe;
	transition: transform 1s;

	.container {
		position: relative;
		display: flex;
		align-items: center;
		position: relative;

		.logo {
			position: absolute;
			z-index: 100;
			left: 0;
			top: 50%;
			transform: translate(0, -50%);
			width: 164px;
			height: 42px;
			text-align: center;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.header-nav {
		flex: 1;
		display: flex;
		justify-content: flex-end;
		align-items: center;

		.item {
			display: inline-block;
			height: 100%;
			line-height: 75px;
			text-align: center;

			.router {
				text-decoration: none;
			}
		}
	}

	.phone-consult {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		border-radius: 30px;
		color: #fff;
		background-color: #1776f2;
	}

	.menu {
		display: none;
		position: absolute;
		z-index: -10;
		overflow-y: scroll;
		top: 0;
		right: 0;
		width: 60vw;
		border: none;
	}

	.button {
		position: absolute;
		pointer-events: none;
		z-index: 20;
		top: 50%;
		transform: translate(0, -50%);
		right: 0;
		display: none;
		place-items: center;
		font-size: 32px;
		color: #000;
		width: 50px;
		height: 50px;
		line-height: 50px;
		background-color: #fcfdfe;

		.el-icon-close {
			color: #fff;
			font-size: 24px;
		}

		.el-icon-s-fold {
			width: 25px;
			height: 25px;
		}
	}

	.tree-menu {
		display: none;
	}

}

.router {
	.el-dropdown-link {
		position: relative;
		display: inline-block;
		height: 100%;
		font-size: 16px;
		padding: 0 10px;
		color: #222222;
	}

	.el-dropdown-link:hover {
		color: #0e90d2;
		cursor: pointer;
	}

	.el-dropdown-link:hover .underline {
		width: 100%;
	}

	.underline {
		position: absolute;
		bottom: 0;
		left: 0;
		display: inline-block;
		height: 2px;
		background-color: #007bff;
		width: 0;
		border-radius: 1px;
		transition: width 0.3s, left 0.3s;
	}
}

::v-deep .el-dropdown {
	font-size: inherit;
}

.el-dropdown-menu {
	background-color: #fcfdfe !important;
	border: none;

	.item-flex {
		padding: 0 10px;
	}

	.item {
		color: black;
	}

	.second-title {
		display: flex;
		align-items: center;
		margin-right: 3px;
		font-size: 14px;
		font-weight: 700;
		cursor: default;
	}

	.icon {
		padding-top: 1px;
	}

	.third-title {
		color: black;
		font-size: 12px;
	}

	.el-dropdown-menu__item:hover {
		color: #076ce0;
		background-color: transparent;
	}
}

@media screen and (max-width: 1024px) {
	.header-nav {
		display: none !important;
	}

	.tree-menu {
		display: block !important;
	}

	.menu {
		display: block !important;
	}

	.button {
		display: block !important;
	}
}

/*响应式布局*/
@media screen and (min-width: 0) {
	.header {
		height: 75px;

		.header-nav {
			height: 60px;

			.item {
				width: 120px;
			}
		}

		.phone-consult {
			display: none;
		}
	}
}

@media screen and (min-width: 768px) {
	.header {
		height: 75px;

		.header-nav {
			height: 75px;

			.item {
				width: 120px;
			}
		}

		.phone-consult {
			display: none;
		}
	}
}

@media screen and (min-width: 1024px) {
	.header {
		height: 75px;

		.header-nav {
			height: 75px;

			.item {
				width: 120px;
			}
		}

		.phone-consult {
			display: none;
		}
	}
}

@media screen and (min-width: 1440px) {
	.header {
		height: 75px;

		.header-nav {
			height: 75px;

			.item {
				width: 120px;
			}
		}

		.phone-consult {
			display: block;
		}
	}
}

@media screen and (min-width: 1880px) {
	.header {
		height: 75px;

		.header-nav {
			height: 75px;

			.item {
				width: 240px;
			}
		}

		.phone-consult {
			display: block;
		}
	}
}
</style>
